import loadable from '@loadable/component'

export const CountryOfAnalyst = loadable(() => import('./CountryOfAnalyst'))
export const CountryOfFitchOffice = loadable(
  () => import('./CountryOfFitchOffice')
)
export const Disclosures = loadable(() => import('./Disclosures'))
export const EndorsementStatus = loadable(() => import('./EndorsementStatus'))
export const ESGRatings = loadable(() => import('./ESGRatings'))
export const OriginalRatings = loadable(() => import('./OriginalRatings'))
export const PermissibleServices = loadable(
  () => import('./PermissibleServices')
)
export const Solicitations = loadable(() => import('./Solicitations'))
export type { CountryOfAnalystProps } from './CountryOfAnalyst'
export type { CountryOfFitchOfficeProps } from './CountryOfFitchOffice'
export type { DisclosuresProps } from './Disclosures'
export type {
  EndorsementStatusItemProps,
  EndorsementStatusProps
} from './EndorsementStatus'
